<template>
  <div class="bootstrap-wrapper">
    <div class="container">
      <DirPath
        :path="['Reportes', 'Detalle por habilidad de comprensión lectora']"
      />
      <HeaderView v-bind="headerData" />

      <ReportsConfig v-if="!reports.school || !reports.course" />
      <template v-if="!reports.school && !reports.course">
        <div class="row">
          <div class="col text-center">
            <Spinner v-if="showSpinner" />
          </div>
        </div>
      </template>

      <template v-if="reports.school && reports.course">
        <HeaderReport :title="'Respuestas en total'" />
      </template>

      <template v-if="reports.school && reports.course && showData">
        <div class="row my-5">
          <div class="text-center">
            <router-link
              :to="'/dashboard/analytics/reports/detailBySkill'"
              v-slot="{ href, route, navigate, isExactActive }"
            >
              <button
                :href="href"
                @click="navigate"
                :class="[
                  isExactActive && 'secondary',
                  !isExactActive && 'primary',
                ]"
                class="button mx-1"
              >
                Respuestas en total
              </button>
            </router-link>
            <router-link
              :to="
                '/dashboard/analytics/reports/detailBySkill/DetailInChallenges'
              "
              v-slot="{ href, route, navigate, isActive }"
            >
              <button
                :href="href"
                @click="navigate"
                :class="[isActive && 'secondary', !isActive && 'primary']"
                class="button mx-1"
              >
                Detalles en desafíos
              </button>
            </router-link>
            <router-link
              :to="'/dashboard/analytics/reports/detailBySkill/DetailInBooks'"
              v-slot="{ href, route, navigate, isActive }"
            >
              <button
                :href="href"
                @click="navigate"
                :class="[isActive && 'secondary', !isActive && 'primary']"
                class="button mx-1"
              >
                Detalles en libros
              </button>
            </router-link>
            <router-link
              :to="'/dashboard/analytics/reports/detailBySkill/Students'"
              v-slot="{ href, route, navigate, isActive }"
            >
              <button
                :href="href"
                @click="navigate"
                :class="[isActive && 'secondary', !isActive && 'primary']"
                class="button mx-1"
              >
                Agrupar estudiantes por habilidad más descendida
              </button>
            </router-link>
          </div>
        </div>

        <template v-if="showData">
          <router-view :data="data" />
        </template>
        <template v-else>
          <div class="row">
            <div class="col text-center">
              <Spinner v-if="showSpinner" />
            </div>
          </div>
        </template>
      </template>
      <div class="row" v-if="showSpinner">
        <div class="col text-center">
          <Spinner v-if="showSpinner" />
        </div>
      </div>

      <div class="row">
        <FooterComponent />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import DirPath from "@/components/DirPath";
import FooterComponent from "@/components/Footer";
import HeaderReport from "@/components/HeaderReport";
import HeaderView from "@/components/HeaderView";
import ReportsConfig from "@/components/ReportsConfig";
import Spinner from "@/components/Spinner";

export default {
  name: "detailBySkill",
  components: {
    DirPath,
    FooterComponent,
    HeaderReport,
    HeaderView,
    ReportsConfig,
    Spinner,
  },
  data() {
    let { secCol } = this.$store.getters;

    return {
      headerData: {
        title: "Detalle por habilidad de comprensión lectora",
        subTitle: "",
        body:
          "Mira qué tal van tus estudiantes en comprensión lectora, habilidad por habilidad",
        img: require("@/assets/images/Componente 31 – 1.svg"),
      },
      secCol,
      data: null,
      showData: false,
      showSpinner: false,
    };
  },
  computed: {
    ...mapState(["dataUrl", "reports"]),
  },
  watch: {
    "reports.dateFilterVal"() {
      if (this.reports.dateFilterVal) this.getReportData();
    },
    "reports.initialDate"() {
      if (this.reports.dateFilterVal == 3) this.getReportData();
    },
    "reports.endDate"() {
      if (this.reports.dateFilterVal == 3) this.getReportData();
    },
  },
  methods: {
    async getReportData() {
      if (!this.reports.dateFilterVal) return;

      let endpoint;
      this.showData = false;
      this.showSpinner = true;

      switch (this.reports.dateFilterVal) {
        case "1":
          endpoint = `/report/getGeneralDataCurrentMonth?courseId=${this.reports.course}`;
          break;
        case "2":
          endpoint = `/report/getGeneralDataLast30Days?courseId=${this.reports.course}`;
          break;
        case "3":
          if (this.reports.initialDate && this.reports.endDate) {
            endpoint = `/report/getGeneralDataBetweenDates?courseId=${this.reports.course}&fromDate=${this.reports.initialDate}&toDate=${this.reports.endDate}`;
          } else {
            this.showSpinner = false;
            return;
          }
          break;
      }

      let apiUrl = `${this.dataUrl}${endpoint}`;

      try {
        let { data } = await this.axios.get(apiUrl);

        this.data = data.content;
        this.showData = true;
        this.showSpinner = false;
      } catch {
        this.$notify({
          title: ["Ocurrió un error"],
          type: "danger",
        });
        // this.getReportData();
      }
    },
  },
  mounted() {
    this.getReportData();
  },
};
</script>
